/**
 * @generated SignedSource<<ce4efc610d5420d68ad369996850b6bf>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type ReportStatus = "DRAFT" | "ERROR" | "PENDING" | "PROCESSING" | "SUCCESS" | "%future added value";
export type ReportUserFileType = "EXPORT" | "INPUT" | "OUTPUT" | "SOURCE" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type ReportSources_report$data = {
  readonly id: string;
  readonly status: ReportStatus;
  readonly reportUserFiles: {
    readonly nodes: ReadonlyArray<{
      readonly type: ReportUserFileType;
      readonly userFile: {
        readonly id: string;
        readonly rowId: any;
        readonly kind: string;
        readonly name: string;
        readonly key: string;
      } | null;
    }>;
  };
  readonly " $fragmentType": "ReportSources_report";
};
export type ReportSources_report$key = {
  readonly " $data"?: ReportSources_report$data;
  readonly " $fragmentSpreads": FragmentRefs<"ReportSources_report">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ReportSources_report",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ReportUserFilesConnection",
      "kind": "LinkedField",
      "name": "reportUserFiles",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ReportUserFile",
          "kind": "LinkedField",
          "name": "nodes",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "type",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "UserFile",
              "kind": "LinkedField",
              "name": "userFile",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "rowId",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "kind",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "name",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "key",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Report",
  "abstractKey": null
};
})();

(node as any).hash = "27c839ad51d689f5a407db39bb5c114a";

export default node;
